/** Sitting in meditation: the qin alone over a held drone, slow breaths of stopped notes and harmonics. */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const A = `@mp 1,- 2,/ 3, | 5,~--- | 6,/- 5, 3, | 2,~--- | 3,_ 5,_ 6,- 1 | 6,\\- 5,- | 3,. 2,_ 1, 2, | 1,~---`;
const B = `@mp 5* 3* 2*- | 1*--- | 2* 3* 5* 6* | 5*--- | 1'* 6* 5*- | 3*- 2*- | 1* 2* 3*- | 1*---`;
const BOWL = `b--- | 0--- | 0--- | 0--- | 0--- | 0--- | 0--- | 0---`;

registerTrack({
  id: 'meditation',
  order: 14,
  title: 'ลมหายใจกับสายฉิน',
  mood: 'สงบนิ่งที่สุด ภาวนา',
  use: 'ขณะนั่งสมาธิ',
  key: 'C',
  mode: 'gong',
  bpm: 48,
  meter: 4,
  seed: 1414,
  humanize: 0.7,
  parts: {
    qin: { inst: 'qin', reverb: 0.55 },
    pad: { inst: 'pad', gain: 0.55, reverb: 0.6 },
    bowl: { inst: 'perc', gain: 0.2, pan: 0.2, reverb: 0.7 },
  },
  sections: {
    A: { bars: 8, parts: { qin: A, pad: drone(`1, 1, 1, 1, 1, 1, 1, 1,`, 4), bowl: BOWL } },
    B: { bars: 8, parts: { qin: B, pad: drone(`1, 1, 6,, 1, 1, 6,, 5,, 1,`, 4), bowl: BOWL } },
  },
  form: ['A', 'B', 'A', 'B'],
  loop: true,
});
